/*
 * The environment a run executed in, named — and only when it is NOT the company default.
 *
 * Every run has an environment, so tagging them all would put the same word on every row and say
 * nothing. The tag exists to answer "why did this run behave differently", which is only ever true of
 * a non-default environment. An id with no matching environment row (a deleted environment) is shown
 * as the id: the run really did happen somewhere, and blanking it would read as "the default". Until the
 * company's environments have loaded nothing is tagged: every id would read as unknown, the default's too.
 */
const resolveWorkflowRunEnvironmentName = ({ run, environments } = {}) => {
  const environmentId = String(run?.meta?.environmentId || '').trim();

  if (!environmentId) {
    return null;
  }

  if (!Array.isArray(environments) || environments.length === 0) {
    return null;
  }

  const environment = environments.find((item) => String(item?.id || '').trim() === environmentId) || null;

  if (environment?.isDefault === true) {
    return null;
  }

  return String(environment?.name || '').trim() || environmentId;
};

export default resolveWorkflowRunEnvironmentName;
